import { useWeb3 } from "./useWeb3";
import BigNumber from 'bignumber.js'

//lib
import { consolelog } from "../lib/consolelog";
import { toFixedNumber } from "../lib/FixedNumber";


// export const EstGas = async (params, abi, contractAddress, methodName,account) => {
//     try {
//         const web3 = await useWeb3();
//         const gasPrice = await web3.eth.getGasPrice();

//         const gasPrice2 = localStorage.getItem('gasPrice')
//         console.log(gasPrice,gasPrice2,"EstGas")
        
//         const Contract = new web3.eth.Contract(abi, contractAddress)
//         const encoded = await Contract.methods[methodName].apply(null,params).encodeABI();
//         let estimatedGasLimit = await web3.eth.estimateGas({
//             from:web3.utils.toChecksumAddress(account),
//             to: web3.utils.toChecksumAddress(contractAddress),
//             data: encoded,
//         });

//         return{
//             gasLimit:parseInt(estimatedGasLimit* 1.5,10),
//             gasPrice:JSON.parse(gasPrice2)?.gasPrice
//         }
//     } catch (e) {
//         consolelog('EstGas_err',e,true);
//         return false
//     }
// }


import Web3 from "web3";

export const EstGas = async (params, abi, contractAddress, methodName, account) => {
    console.log('methodssssss',params, abi, contractAddress, methodName, account);
  try {
    // 1️⃣ Initialize web3 first
    let web3;
    if (window.ethereum) {
      web3 = new Web3(window.ethereum);
    } else if (window.web3) {
      web3 = new Web3(window.web3.currentProvider);
    } else {
      throw new Error("No web3 provider found");
    }

    // 2️⃣ Validate addresses AFTER web3 is available
    if (!account || !web3.utils.isAddress(account)) {
      throw new Error("Invalid wallet address");
    }

    if (!contractAddress || !web3.utils.isAddress(contractAddress)) {
      throw new Error("Invalid contract address");
    }

    // 3️⃣ Get gas price
    const gasPriceFromChain = await web3.eth.getGasPrice();
    const gasPriceStorage = JSON.parse(localStorage.getItem("gasPrice"))?.gasPrice;

    // 4️⃣ Create contract and encode method call
    const contract = new web3.eth.Contract(abi, contractAddress);
    const encoded = contract.methods[methodName](...params).encodeABI();

    // 5️⃣ Estimate gas
    const estimatedGas = await web3.eth.estimateGas({
      from: web3.utils.toChecksumAddress(account),
      to: web3.utils.toChecksumAddress(contractAddress),
      data: encoded,
    });

    return {
      gasLimit: parseInt(estimatedGas * 1.5, 10),
      gasPrice: gasPriceStorage || gasPriceFromChain,
    };
  } catch (e) {
    console.error("EstGas_err", e);
    return false;
  }
};


export const parsefunction = (num) =>{
  try{
return parseFloat(num.toFixed(2))
  }
  catch(err){
      console.log(err,"parsefunctionerr")
      return 0
  }
}

export const Dateconverter = (date) =>{
  try{
    var options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true
    }; 
    var today = new Date(date);

    return today.toLocaleString("en-US", options)
  }

  catch(err){
      console.log(err,"parsefunctionerr")
      return 0
  }
}